import { LanguageEnum } from '../enums/language.enum';
import { enumToCode } from './lang';

export const getPartnerLink = (code: string, lang?: LanguageEnum): string => {
    const langParams = lang !== undefined ? `lang=${enumToCode(lang)}` : '';
    return `${window.location.origin}/partner?code=${code}&${langParams}&zipCoded=true`;
};
